import { render, staticRenderFns } from "./OfferingPDF.vue?vue&type=template&id=88e8616a&scoped=true"
import script from "./OfferingPDF.vue?vue&type=script&lang=js"
export * from "./OfferingPDF.vue?vue&type=script&lang=js"
import style0 from "./OfferingPDF.vue?vue&type=style&index=0&id=88e8616a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e8616a",
  null
  
)

export default component.exports